import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center ">
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
